export default "__VITE_ASSET__0cfe5be8__"